import React from "react";
import "../styles/InfoDocumentos.css";
import { useAuth } from "../context/AuthContext.jsx";
import FileManager from "./FileManager.jsx";
import { Briefcase } from 'lucide-react';

const InfoCompras = () => {
  const { isAdmin } = useAuth();
  return (
      <div className="doc-page-container" style={{'--doc-color': '#34495e', '--doc-bg-color': '#f2f4f4'}}>
        <div className="doc-page-card">
          <div className="doc-page-header">
            <div className="doc-page-icon"><Briefcase size={48} /></div>
            <h2 className="doc-page-title">Compras y Contrataciones</h2>
          </div>
          <p className="doc-page-text">Acceso público a los expedientes de compras y contrataciones de la Comuna.</p>
          <FileManager tableName="compras_files" folderName="compras" bucketName="compras" isAdmin={isAdmin} />
        </div>
      </div>
  );
};
export default InfoCompras;